import React, { Component } from 'react';
import LargeHeading from "./LargeHeading";

class WorkItem extends Component {

    openInNewTab(url) {
        let win = window.open(url, '_blank');
        win.focus();
    }

    render() {
        const Duplicates = () => {
            let dupes = [];
            for (let i = 1; i <= 4; i++) {
                dupes.push(<div key={i}>
                    <img src={'/images/' + this.props.image} alt={this.props.title} />
                </div>);
            }
            return dupes;
        };

        return (
            <div className="work-item" id={this.props.id}>
                <div
                    className="inner"
                    onMouseEnter={() => this.props.handleMouseEnter(this)}
                    onMouseLeave={() => this.props.handleMouseLeave(this)}
                >
                    <div className="bg-cover" />
                    <div className="imagery">
                        <div className="main">
                            <div className="dot dot-left" />
                            <div className="dot dot-right" />
                            <div className="wiper wiper-left">
                                <div className="inner-dot" />
                            </div>
                            <div className="wiper wiper-right">
                                <div className="inner-dot" />
                            </div>
                            <div className="wiper-horizontal wiper-top" />
                            <div className="wiper-horizontal wiper-bottom" />
                            <img src={'/images/' + this.props.image} alt={this.props.title} />
                        </div>
                        {Duplicates()}
                    </div>
					<div className="title d-none d-lg-flex" onClick={() => this.openInNewTab(this.props.url)}>
						<div className="dot dot-left" />
						<div className="dot dot-right" />
						<LargeHeading title={this.props.title} count="4" />
						<div className="blurb">
							<p dangerouslySetInnerHTML={{__html: this.props.description}} />
							<p dangerouslySetInnerHTML={{__html: this.props.skills}} className='font-weight-bold' />
						</div>
					</div>
                </div>
            </div>
        );
    }
    
}

export default WorkItem;


// WEBPACK FOOTER //
// ./src/js/components/WorkItem.js